<template>
    <div class="project-integration">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               @before-close="beforeClose"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <header>
                    <h4 v-if="model.created_at && model.integration" class="display-block">
                        {{model.integration.title}}
                        <span v-html="model.integration.typeLabel"></span>
                        <span v-html="model.typeLabel"></span>
                        <span v-if="model.archivedLabel" v-html="model.archivedLabel"></span>
                    </h4>
                    <h4 v-else>Create Integration</h4>

                    <h5 v-if="model.created_at">Integration</h5>

                    <a href="javascript://void(0)" class="back" @click="closeModal">Close</a>
                </header>

                <form @submit.prevent="saveModel" accept-charset="UTF-8" novalidate="novalidate"
                      data-vv-scope="projectIntegration">
                    <fieldset>
                        <legend>Integration</legend>

                        <div class="form-group has-feedback"
                             :class="{'has-error': errors.has('projectIntegration.ProjectIntegration[type]')}">
                            <div class="btn-group btn-group-justified" role="group">
                                <div class="btn-group" role="group">
                                    <button type="button"
                                            :class="{ active: model.type === TYPE_CREDENTIAL }"
                                            class="btn btn-sm btn-info"
                                            @click="model.type = TYPE_CREDENTIAL">
                                        Credentials
                                    </button>
                                </div>

                                <div class="btn-group" role="group">
                                    <button type="button"
                                            :class="{ active: model.type === TYPE_MONITOR }"
                                            class="btn btn-sm btn-info"
                                            @click="model.type = TYPE_MONITOR">
                                        Monitoring
                                    </button>
                                </div>

                                <div class="btn-group" role="group">
                                    <button type="button"
                                            :class="{ active: model.type === TYPE_RESIDENT }"
                                            class="btn btn-sm btn-primary"
                                            @click="model.type = TYPE_RESIDENT">
                                        Residents
                                    </button>
                                </div>

                                <div class="btn-group" role="group">
                                    <button type="button"
                                            :class="{ active: model.type === TYPE_BILLING }"
                                            class="btn btn-sm btn-primary"
                                            @click="model.type = TYPE_BILLING">
                                        Billing
                                    </button>
                                </div>
                            </div>

                            <span v-show="errors.has('projectIntegration.ProjectIntegration[type]')" class="help-block">
                                {{ errors.first('projectIntegration.ProjectIntegration[type]') }}
                            </span>
                        </div>

                        <div v-if="!model.created_at"
                             class="form-group has-feedback"
                             :class="{'has-error': errors.has('projectIntegration.ProjectIntegration[integration_id]')}">
                            <label for="project-integration-integration-id">Integration</label>

                            <select id="project-integration-integration-id"
                                    name="ProjectIntegration[integration_id]"
                                    class="form-control"
                                    v-validate="'required'"
                                    v-model="model.integration_id">
                                <option selected="selected" value="">-</option>
                                <option v-for="integration in integrations" :key="integration.id"
                                        :value="integration.id">
                                    {{integration.title}}
                                </option>
                            </select>

                            <span v-show="errors.has('projectIntegration.ProjectIntegration[integration_id]')"
                                  class="help-block">
                                {{ errors.first('projectIntegration.ProjectIntegration[integration_id]') }}
                            </span>
                        </div>

                        <div class="row">
                            <div class="col-xs-6 col-sm-4 form-group pull-right">
                                <label class="pointer">
                                    Enter External Id

                                    <input autocomplete="off"
                                        v-model="manualExternalId"
                                        id="manual-external-id"
                                        name="manual-external-id"
                                        type="checkbox" aria-required="true">
                                </label>
                            </div>
                        </div>

                        <div v-if="manualExternalId">
                            <div class="form-group has-feedback"
                                :class="{'has-error': errors.has('projectIntegration.ProjectIntegration[external_id]')}">
                                <label for="project-integration-manual-external-id">External Id</label> <i class="fa fa-info-circle text-gray tool-tip"><span class="tool-tip-text">For Inkit Paper Invoice Integration, this will be the Inkit Template ID for the Letters API</span></i>

                                <input id="project-integration-manual-external-id"
                                    name="ProjectIntegration[external_id]"
                                    type="text"
                                    class="form-control"
                                    v-model="model.external_id"
                                    v-validate="'required'">

                                <span v-show="errors.has('projectIntegration.ProjectIntegration[external_id]')" class="help-block">
                                    {{ errors.first('projectIntegration.ProjectIntegration[external_id]') }}
                                </span>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="!model.created_at && model.integration_id && properties.length === 0"
                                class="form-group">
                                <button type="button" @click="loadIntegrationProperties" class="btn btn-primary btn-sm">
                                    Load Properties
                                </button>
                            </div>

                            <div v-else-if="!model.created_at && model.integration_id"
                                class="form-group has-feedback"
                                :class="{'has-error': errors.has('projectIntegration.ProjectIntegration[external_id]')}">
                                <label for="project-integration-external-id">Integration</label>

                                <select id="project-integration-external-id"
                                        name="ProjectIntegration[external_id]"
                                        class="form-control"
                                        v-validate="'required'"
                                        v-model="model.external_id">
                                    <option selected="selected" value="">-</option>
                                    <option v-for="property in properties" :key="property.id"
                                            :value="property.id">
                                        {{property.name}}
                                    </option>
                                </select>

                                <span v-show="errors.has('projectIntegration.ProjectIntegration[external_id]')"
                                    class="help-block">
                                {{ errors.first('projectIntegration.ProjectIntegration[external_id]') }}
                            </span>
                            </div>
                        </div>

                        <div v-if="model.type === TYPE_BILLING">
                            <div class="form-group has-feedback"
                                :class="{'has-error': errors.has('projectIntegration.ProjectIntegration[start_at]')}">
                                <label for="project-integration-start-at">Start Billing On</label> <i class="fa fa-info-circle text-gray tool-tip"><span class="tool-tip-text">The day to begin Billing via the Integration. Any charges generated before this date will be ignored.</span></i>

                                <input id="project-integration-start-at"
                                    name="ProjectIntegration[start_at]"
                                    type="date"
                                    class="form-control"
                                    v-model="model.start_at"
                                    v-validate="'required'">

                                <span v-show="errors.has('projectIntegration.ProjectIntegration[start_at]')" class="help-block">
                                    {{ errors.first('projectIntegration.ProjectIntegration[start_at]') }}
                                </span>
                            </div>

                            <div class="form-group has-feedback"
                                :class="{'has-error': errors.has('projectIntegration.ProjectIntegration[billing_post_date]')}">
                                <label for="project-integration-billing-post-date">Billing Post Day of Month</label>

                                <input id="project-integration-billing-post-date"
                                    name="ProjectIntegration[billing_post_date]"
                                    type="number"
                                    class="form-control"
                                    v-model="model.billing_post_date"
                                    v-validate="'required'">

                                <span v-show="errors.has('projectIntegration.ProjectIntegration[billing_post_date]')" class="help-block">
                                    {{ errors.first('projectIntegration.ProjectIntegration[billing_post_date]') }}
                                </span>
                            </div>

                            <div v-if="model.type === TYPE_BILLING && (integrations.filter(i => i.id === model.integration_id).length > 0 ? integrations.filter(i => i.id === model.integration_id)[0].title === 'Inkit Paper Invoice' : false)">
                                <div class="form-group has-feedback"
                                    :class="{'has-error': errors.has('projectIntegration.ProjectIntegration[property_name_short]')}">
                                    <label for="project-integration-property-name-short">Property Name Short</label> <i class="fa fa-info-circle text-gray tool-tip"><span class="tool-tip-text">Verify this field using Inkit GUI before integration setup</span></i>

                                    <input id="project-integration-property-name-short"
                                        name="ProjectIntegration[property_name_short]"
                                        type="text"
                                        class="form-control"
                                        v-model="model.property_name_short"
                                        v-validate="'required'">

                                    <span v-show="errors.has('projectIntegration.ProjectIntegration[property_name_short]')" class="help-block">
                                        {{ errors.first('projectIntegration.ProjectIntegration[property_name_short]') }}
                                    </span>
                                </div>

                                <div class="form-group has-feedback"
                                    :class="{'has-error': errors.has('projectIntegration.ProjectIntegration[property_name_long]')}">
                                    <label for="project-integration-property-name-long">Property Name Long</label> <i class="fa fa-info-circle text-gray tool-tip"><span class="tool-tip-text">Verify this field using Inkit GUI before integration setup</span></i>

                                    <input id="project-integration-property-name-long"
                                        name="ProjectIntegration[property_name_long]"
                                        type="text"
                                        class="form-control"
                                        v-model="model.property_name_long"
                                        v-validate="'required'">

                                    <span v-show="errors.has('projectIntegration.ProjectIntegration[property_name_long]')" class="help-block">
                                        {{ errors.first('projectIntegration.ProjectIntegration[property_name_long]') }}
                                    </span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="form-group has-feedback"
                                    :class="{'has-error': errors.has('projectIntegration.ProjectIntegration[billing_charge_code_id]')}">
                                    <label for="project-integration-billing-charge-code-id">Billing Charge Code Id</label> <i class="fa fa-info-circle text-gray tool-tip"><span class="tool-tip-text">Charge Code Id provided by the client to associate charges with a specific ledger account</span></i>

                                    <input id="project-integration-billing-charge-code-id"
                                        name="ProjectIntegration[billing_charge_code_id]"
                                        type="text"
                                        class="form-control"
                                        v-model="model.billing_charge_code_id"
                                        v-validate="'required'">

                                    <span v-show="errors.has('projectIntegration.ProjectIntegration[billing_charge_code_id]')" class="help-block">
                                        {{ errors.first('projectIntegration.ProjectIntegration[billing_charge_code_id]') }}
                                    </span>
                                </div>

                                <div class="form-group has-feedback"
                                    :class="{'has-error': errors.has('projectIntegration.ProjectIntegration[secret_version]')}">
                                    <label for="project-integration-secret-version">Secret Version</label> <i class="fa fa-info-circle text-gray tool-tip"><span class="tool-tip-text">GCP Secret Version associated with the integration</span></i>

                                    <input id="project-integration-secret-version"
                                        name="ProjectIntegration[secret_version]"
                                        type="text"
                                        class="form-control"
                                        v-model="model.secret_version"
                                        v-validate="'required'">

                                    <span v-show="errors.has('projectIntegration.ProjectIntegration[secret_version]')" class="help-block">
                                        {{ errors.first('projectIntegration.ProjectIntegration[secret_version]') }}
                                    </span>
                                </div>

                                <div class="form-group has-feedback"
                                    :class="{'has-error': errors.has('projectIntegration.ProjectIntegration[property_code]')}">
                                    <label for="project-integration-property-code">Property Code</label> <i class="fa fa-info-circle text-gray tool-tip"><span class="tool-tip-text">Associated Property Code assigned by the Property Management Software</span></i>

                                    <input id="project-integration-property-code"
                                        name="ProjectIntegration[property_code]"
                                        type="text"
                                        class="form-control"
                                        v-model="model.property_code"
                                        v-validate="'required'">

                                    <span v-show="errors.has('projectIntegration.ProjectIntegration[property_code]')" class="help-block">
                                        {{ errors.first('projectIntegration.ProjectIntegration[property_code]') }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-xs-6">
                                <button type="button" class="btn btn-sm btn-warning"
                                        @click="deleteModel"
                                        v-if="model.created_at && model.deleted_at === null"
                                        :disabled="loading">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>

                                <button type="button" class="btn btn-sm btn-warning"
                                        @click="restoreModel"
                                        v-if="model.created_at && model.deleted_at !== null"
                                        :disabled="loading">
                                    <i class="fa fa-refresh" aria-hidden="true"></i>
                                </button>
                            </div>

                            <div class="col-xs-6 form-group pull-right">
                                <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                    Save
                                </button>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </modal>
    </div>
</template>

<script>
    import model from "./mixins/model";

    const TYPE_CREDENTIAL = 0;
    const TYPE_MONITOR = 1;
    const TYPE_RESIDENT = 2;
    const TYPE_BILLING = 3;

    export default {
        mixins: [ model ],

        props: {
            projectId: {
                type: String,
                default: null
            },
        },

        computed: {
            saveValidationKey(){
                return 'projectIntegration'
            },

            resourceKey(){
                return 'ProjectIntegration';
            },

            url(){
                if( this.model.id ){
                    return '/api/projectIntegrations/' + this.model.id;
                }
                else {
                    return '/api/projectIntegrations';
                }
            },
        },

        watch: {
            'model.integration_id'(){
                if( this.model.integration_id ){
                    this.properties.splice( 0, this.properties.length );
                }
            }
        },

        methods: {
            beforeLoad(){
                return this.loadIntegrations();
            },

            afterLoad(){
                if (this.model.start_at !==  null)
                    this.$set( this.model, 'start_at', moment.utc( this.model.start_at ).format( 'YYYY-MM-DD' ) );
            },

            beforeSave(){
                this.model.project_id = this.projectId;
            },

            getModelData(){
                return {
                    integrations: [],
                    properties: [],

                    manualExternalId: false,

                    model: {
                        type: 0
                    },

                    TYPE_CREDENTIAL,
                    TYPE_MONITOR,
                    TYPE_RESIDENT,
                    TYPE_BILLING,
                };
            },

            loadIntegrations(){
                var url = '/api/integrations';

                return axios.get( url )
                    .then( ( response ) => {
                        this.$set( this, 'integrations', response.data.Integrations );
                    } );
            },

            loadIntegrationProperties(){
                this.loading = true;

                return axios.get( '/api/integrations/' + this.model.integration_id + '?_load[]=properties' )
                    .then( ( response ) => {
                        this.$set( this, 'properties', response.data.Integration.properties );
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( ( err ) => {
                        return this.$root.handleErrors( err, this.saveValidationKey );
                    } );
            },

            toggleManualExternalId(){
                this.$set( this, 'manualExternalId', !this.manualExternalId );
            }
        }
    }
</script>
